module.exports = __webpack_public_path__ + "static/laundromatslider-02-min-d6b3cabe2bf4adfc1eba7fa97577e1b0.jpg";